import type { Control, FieldValues, Path } from "react-hook-form";
import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { FlatRowFormSelect } from "web_myplann/Shared/Components/FlatRow/FlatRowFormSelect";
import { useEnumSelectOptions } from "web_myplann/Shared/Hooks/useEnumSelectOptions";

type BuildingSavingsContractFieldsProps<
	FormType extends FieldValues,
	TContext,
	TTransformed extends FieldValues | undefined,
> = {
	control: Control<FormType, TContext, TTransformed>;
};

export const BuildingSavingsContractFields = <
	FormType extends FieldValues,
	TContext,
	TTransformed extends FieldValues | undefined,
>({
	control,
}: BuildingSavingsContractFieldsProps<FormType, TContext, TTransformed>) => {
	const { t } = useResource();

	const paymentFrequencyOptions = useEnumSelectOptions(
		ClientPortfolioPaymentFrequencyEnum,
		Resources.PortfolioDetail.SharedLabels.Frequency,
		[ClientPortfolioPaymentFrequencyEnum.None],
	);

	return (
		<>
			<FlatRowFormInput
				control={control}
				name={"payment" as Path<FormType>}
				type="float"
				label={t(Resources.Portfolio.AddBuildingSavings.Fields.payment)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix="Kč"
			/>
			<FlatRowFormSelect
				control={control}
				name={"paymentFrequency" as Path<FormType>}
				label={t(
					Resources.Portfolio.AddBuildingSavings.Fields.paymentFrequency,
				)}
				options={paymentFrequencyOptions}
			/>
			<FlatRowFormInput
				control={control}
				name={"targetAmount" as Path<FormType>}
				type="float"
				label={t(Resources.Portfolio.AddBuildingSavings.Fields.targetAmount)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix="Kč"
			/>
			<FlatRowFormInput
				control={control}
				name={"appreciation" as Path<FormType>}
				type="float"
				label={t(Resources.Portfolio.AddBuildingSavings.Fields.appreciation)}
				placeholder={t(Resources.Portfolio.AddShared.Placeholders.fill)}
				suffix="%"
				isLast
			/>
		</>
	);
};
